import React from 'react';

const LoadingScreen: React.FC = () => {
    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="animate-spin rounded-full h-20 w-20 border-b-2 border-primary-600"></div>
        </div>
    );
};

export default LoadingScreen;